module.exports = __webpack_public_path__ + "img/删除.e0a1c56c.svg";